import React from "react";
import '../../style.scss';
import './style.scss';
import { Modal, Button } from "antd";
import ButtonRoaming from "../ButtonRoaming/ButtonRoaming";

const BottomSheet = ({ 
  isVisible,
  onClose,
  onAction1,
  onAction2,
  action1Text,
  action2Text,
  action1IsDisabled = false,
  action2IsDisabled = false,
  children,
  className,
}) => {
  return (
    <Modal
      open={isVisible}
      onCancel={onClose}
      footer={null}
      className={`custom-bottom-sheet ${className}`}
      maskClosable={true} 
      closable={true}
    >
      <div className="bottom-sheet-content">{children}</div>

      {/* Chỉ hiển thị nếu có truyền text */}
      <div className="bottom-sheet-actions">
        {action1Text && (
          <ButtonRoaming disabled={action1IsDisabled} className="border-primay" onClick={onAction1}>
            {action1Text}
          </ButtonRoaming>
        )}
        {action2Text && (
          <ButtonRoaming disabled={action2IsDisabled} className="primary" onClick={onAction2}>
            {action2Text} 
          </ButtonRoaming>
        )}
      </div>
    </Modal>
  );
};

export default BottomSheet;
